import React from 'react';

export default function Divider() {
  return (
    <div className="hidden sm:block" aria-hidden="true">
      <div className="py-8">
        <div className="border-t border-gray-200" />
      </div>
    </div>
  );
}
